import styled from 'styled-components';

export const StyledAdminCalendar = styled.div`
  position: relative;

  width: 27rem;

  padding: 1rem 1.8rem 1.8rem;

  border: 1px solid
    ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent3)};
  border-radius: 5px;

  color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.text2)};

  background-color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.bg2)};
  box-shadow: ${(props) =>
    props.theme.id === 'dark' ? 'none' : '0px 23px 20px 0px rgba(173, 167, 206, 0.82)'};

  @media screen and (max-width: 768px) {
    width: 32rem;
  }

  .react-calendar__month-view__days__day {
    position: relative;
    z-index: 1;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 3.4rem;
    height: 3.4rem;

    font-size: 1.4rem;
    font-weight: 700;
    line-height: 150%;

    &::before {
      position: absolute;
      z-index: -1;
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.accent1 : props.theme.accent5};
      opacity: 0;
      border-radius: 500px;
    }

    .abbr {
      position: relative;
      z-index: 1;
    }
    &:hover {
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.text3 : props.theme.text2)};
      &::before {
        opacity: 1;
      }
    }

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .react-calendar__month-view__weekdays {
    margin-bottom: 1.3rem;
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text3 : props.theme.accent4)};
  }
  .react-calendar__month-view__weekdays__weekday {
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.accent3 : props.theme.text4)};

    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 27px */

    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.4rem;
    height: 3.4rem;
    padding: 0.2rem 1rem;
    flex-shrink: 0;
    > abbr {
      text-decoration: none;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .react-calendar__tile {
    font-size: 1.4rem;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .react-calendar__year-view__months__month,
  .react-calendar__decade-view__years__year {
    padding: 1rem;
    height: 4.5rem;
  }

  .react-calendar__decade-view__years {
    display: flex;
    justify-content: center;
  }

  .react-calendar__navigation {
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.text2)};

    display: flex;
    justify-content: center;
    margin-bottom: 0.8rem;
  }

  .react-calendar__navigation__label {
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 27px */

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .react-calendar__navigation__arrow {
    width: 3.4rem;
    height: 3.4rem;
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.button2 : props.theme.accent1)};

    > * {
      width: 100%;
      height: 100%;
      display: block;
      rect[fill] {
        fill: currentColor;
        stroke: currentColor;
      }

      path[fill] {
        fill: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.accent3)};
      }
    }

    &:hover {
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.accent1 : props.theme.accent5)};
      > * {
        rect[stroke] {
          stroke: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.text4)};
        }
        path[fill] {
          fill: ${(props) => (props.theme.id === 'dark' ? props.theme.button2 : props.theme.text4)};
        }
      }
    }
  }
  .react-calendar__navigation__next2-button,
  .react-calendar__navigation__prev2-button {
    display: none;
  }

  .react-calendar__tile--active {
    background-color: ${(props) =>
      props.theme.id === 'dark' ? props.theme.button2 : props.theme.accent4};
    &.react-calendar__month-view__days__day--neighboringMonth {
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.button3 : props.theme.text5)};
    }
  }
  .react-calendar__tile--range {
  }
  .react-calendar__tile--rangeStart {
    border-top-left-radius: 500px;
    border-bottom-left-radius: 500px;
    &::before {
      opacity: 1;
    }
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text3 : props.theme.text2)};
  }

  .react-calendar__tile--range {
  }
  .react-calendar__tile--rangeEnd {
    border-top-right-radius: 500px;
    border-bottom-right-radius: 500px;
    &::before {
      opacity: 1;
    }
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text3 : props.theme.text2)};
  }
`;
